module.exports = __webpack_public_path__ + "018a12b2adc7072873d17517d6c6f499.svg";